import { ReportCell } from "@/types/evaluate";

export const getCellValue = (cell?: ReportCell) => {
  if (!cell) return null;

  switch (cell.status) {
    case "COMPLETED":
      const valueToFormat = cell.display_value?.value
        ? cell.display_value.value
        : cell.value?.value;

      return formatCellValue(valueToFormat);

    case "FAILED":
      return cell.error_message;

    default:
      return formatCellValue(cell.value?.value);
  }
};

const formatCellValue = (
  value: string | boolean | number | null | Record<string, any>,
) => {
  if (value === undefined || value === null) {
    return null;
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value;
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return String(value);
  }
};
